
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    alias: null,
    roomId: null,
    userId: null,
    joined: false,
  },
  mutations: {
    setUserId(state, id) {
      state.userId = id;
    },
    setRoomId(state, id) {
      state.roomId = id;
    },
    setAlias(state, a) {
      state.alias = a;
    },
    setJoined(state, f) {
      state.joined = f;
    }
  },
  getters: {
    userId(state) {
      return state.userId;
    },
    roomId(state) {
      return state.roomId;
    },
    alias(state) {
      return state.alias;
    },
    joined(state) {
      return state.joined;
    }
  },
})